<template>
    <FormKit
        type="text"
        name="name"
        label="Имя"
        placeholder="Иванов Иван"
        validation="required|matches:/^[А-ЯЁа-яё]+(\s[А-ЯЁа-яё]+)*$/"
        v-model="selectName"
        :validation-messages="{
            required: 'Укажите имя',
            matches: 'Имя должно содержать только буквы кирилицы'
        }"
    />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'InputName',
    props: ['name'],
    computed: {
        ...mapGetters({
            storeName: 'getName',
        })
    },
    watch: {
        selectName(newSelectName) {
            this.$emit('update:name', newSelectName);
        }
    },
    data: () => {
        return {
            selectName: ''
        }
    },
    mounted() {
        this.selectName = this.storeName;
    }
}
</script>